module.exports = __webpack_public_path__ + "img/gedaempfteknoedelnmitschweinefleisch.20661679.jpg";